export const config = {
  apiKey: "AIzaSyDd4yQ4iaUvPB3_UHe7P_av2S1OXvGP-9A",
  authDomain: "confusionserver-b29fc.firebaseapp.com",
  databaseURL: "https://confusionserver-b29fc.firebaseio.com",
  projectId: "confusionserver-b29fc",
  storageBucket: "confusionserver-b29fc.appspot.com",
  messagingSenderId: "677514544061"
};



// WEBPACK FOOTER //
// ./src/firebase/config.js